import { render, staticRenderFns } from "./LenovoAbout.vue?vue&type=template&id=39ea8b92&"
import script from "./LenovoAbout.vue?vue&type=script&lang=js&"
export * from "./LenovoAbout.vue?vue&type=script&lang=js&"
import style0 from "./LenovoAbout.vue?vue&type=style&index=0&id=39ea8b92&prod&lang=css&"
import style1 from "./LenovoAbout.vue?vue&type=style&index=1&id=39ea8b92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports